import { render } from "./Team_index_en_m.vue?vue&type=template&id=bd84fe04&scoped=true"
import script from "./Team_index_en_m.vue?vue&type=script&lang=js"
export * from "./Team_index_en_m.vue?vue&type=script&lang=js"

import "./Team_index_en_m.vue?vue&type=style&index=0&id=bd84fe04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bd84fe04"

export default script